<button
  (click)="addContato()"
  [disabled]="blocked_actions"
  *ngIf="!readonly"
  mat-raised-button
  color="primary"
  class="mb-4"
  id="add-novo-contato"
>
  <mat-icon>add</mat-icon>
  Adicionar contatos
</button>
<mat-divider></mat-divider>
<div
  *ngIf="entityTemp.contatos.length === 0"
  style="height: 200px;"
  class="flex justify-content-center align-items-center"
>
  <div
    class="flex justify-content-center align-items-center flex-column"
    style="color: #999;"
  >
    <i class="mdi mdi-phone-off-outline icon-format-empty-list"></i>
    <p style="font-size: 16px; text-align: center;">
      Nenhum contato cadastrado
    </p>
  </div>
</div>
<mat-list
  class="row mt-3 justify-content-center"
  [ngClass]="{ 'mat-mdc-list-flex': true }"
  *ngIf="entityTemp.contatos.length > 0"
>
  <mat-list-item
    (click)="readonly ? undefined : editarContato(contato, i)"
    class="col-md-5 card mat-elevation-z5 cursor-pointer mr-2"
    pTooltip="Editar contato"
    *ngFor="let contato of entityTemp.contatos; let i = index"
  >
    <div class="flex align-items-center justify-content-between width-100 p-2">
      <div class="flex flex-column">
        <div matLine class="font-light mb-2">
          <i
            matListIcon
            class="pi pi-fw pi-address-book text-primary fs-small"
          ></i>
          <span matLine class="fs-normal ml-2">{{
            contato.contato.length > 15
              ? contato.contato.substring(0, 15) + '...'
              : contato.contato
          }}</span>
        </div>
        <span class="font-bold" matLine>
          {{
            formatarTags(
              contato.tag.length > 15
                ? contato.tag.substring(0, 15)
                : contato.tag
            )
          }}
        </span>
      </div>
      <button
        [disabled]="readonly"
        (click)="removerContato($event, contato)"
        type="button"
        id="button-remove-item-{{ i }}"
        mat-icon-button
        pTooltip="Remover contato"
      >
        <mat-icon class="text-red-500">delete</mat-icon>
      </button>
    </div>
  </mat-list-item>
</mat-list>
